import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'mmx-data-view-dialog',
  templateUrl: './data-view-dialog.component.html',
  styleUrl: './data-view-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
  ],
})
export class DataViewDialogComponent implements OnInit {
  formattedData: string = ''

  constructor(
    public dialogRef: MatDialogRef<DataViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { dataToDisplay: Record<string, any>, title: string },
  ) { }

  ngOnInit() {
    this.formattedData = JSON.stringify(this.data.dataToDisplay, null, 2)
  }

  onOkClick(): void {
    this.dialogRef.close()
  }
}
